<script>
import { required, email, requiredIf } from 'vuelidate/lib/validators';
import Swal from 'sweetalert2';
import axios from 'axios';
export default {
	data() {
		return {
			submitted: false,
			form: {
				businessName: '',
				howDidYouHear: null,
				howDidYouHearOther: '',
				numberOfVolunteers: '',
				groupType: '',
				groupLeader: {
					firstName: '',
					lastName: '',
				},
				phone: '',
				email: '',
				address: {
					line1: '',
					line2: '',
					city: '',
					state: '',
					zipCode: '',
				},
			},
			howDidYouHearOptions: [
				{ value: 'Your Church', text: 'Your Church' },
				{ value: 'Family', text: 'Family' },
				{ value: 'Friends', text: 'Friends' },
				{ value: 'Staff', text: 'Staff' },
				{ value: 'Online', text: 'Online' },
				{ value: 'Choir', text: 'Choir' },
				{ value: 'Other', text: 'Other' },
			],
		};
	},
	validations: {
		form: {
			businessName: {
				required,
			},
			howDidYouHear: {
				required,
			},
			howDidYouHearOther: {
				required: requiredIf(function () {
					return this.form.howDidYouHear === 'Other';
				}),
			},
			numberOfVolunteers: {
				required,
			},
			groupType: {
				required,
			},
			groupLeader: {
				firstName: { required },
				lastName: { required },
				title: { required },
			},
			phone: {
				required,
			},
			email: {
				required,
				email,
			},
			address: {
				line1: { required },
				city: { required },
				state: { required },
				zipCode: { required },
			},
		},
	},
	methods: {
		reset() {
			const component = this;
			component.form.businessName = '';
			component.form.howDidYouHear = null;
			component.form.howDidYouHearOther = '';
			component.form.numberOfVolunteers = '';
			component.form.groupType = '';
			component.form.groupLeader.firstName = '';
			component.form.groupLeader.lastName = '';
			component.form.groupLeader.title = '';
			component.form.phone = '';
			component.form.email = '';
			component.form.address.line1 = '';
			component.form.address.line2 = '';
			component.form.address.city = '';
			component.form.address.state = '';
			component.form.address.zipCode = '';
		},
		async submit() {
			try {
				const component = this;
				component.submitted = true;
				component.$v.$touch();
				if (component.$v.form.$invalid) {
					Swal.fire({
						title: 'Error!',
						text: 'Please make sure all of the required fields are filled',
						icon: 'error',
						width: 350,
						showConfirmButton: true,
					});
					return;
				}

				let config = { headers: { Accept: 'application/json' } };
				let requestBody = {};
				requestBody.business_name = component.form.businessName ? component.form.businessName : '';
				requestBody.how_did_you_hear = component.form.howDidYouHear ? component.form.howDidYouHear : '';
				requestBody.how_did_you_hear_other = component.form.howDidYouHearOther ? component.form.howDidYouHearOther : '';
				requestBody.number_of_volunteers = component.form.numberOfVolunteers ? component.form.numberOfVolunteers : '';
				requestBody.group_type = component.form.groupType ? component.form.groupType : '';
				requestBody.group_leader_first_name = component.form.groupLeader.firstName ? component.form.groupLeader.firstName : '';
				requestBody.group_leader_last_name = component.form.groupLeader.lastName ? component.form.groupLeader.lastName : '';
				requestBody.group_leader_title = component.form.groupLeader.title ? component.form.groupLeader.title : '';
				requestBody.phone = component.form.phone ? component.form.phone : '';
				requestBody.email = component.form.email ? component.form.email : '';
				requestBody.address_line_1 = component.form.address.line1 ? component.form.address.line1 : '';
				requestBody.address_line_2 = component.form.address.line2 ? component.form.address.line2 : '';
				requestBody.address_city = component.form.address.city ? component.form.address.city : '';
				requestBody.address_state = component.form.address.state ? component.form.address.state : '';
				requestBody.address_zip_code = component.form.address.zipCode ? component.form.address.zipCode : '';

				const response = await axios.post('user/group-volunteer-request', requestBody, config);
				if (response.status != 200) {
					component.submitted = false;
					throw new Error('Invalid response from server');
				}

				Swal.fire({
					title: 'Success!',
					text: 'Request submitted!',
					icon: 'success',
					width: 350,
					showConfirmButton: false,
					timer: 1500,
				});

				component.reset();
				component.submitted = false;
			} catch (error) {
				this.submitted = false;
				Swal.fire({
					title: 'Error!',
					text: error.message || 'Something Went Wrong :(',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
				console.log(error);
			}
		},
	},
};
</script>

<template>
	<b-form class="p-2" @submit.prevent="submit">
		<!-- Row -->
		<div class="row">
			<!-- col -->
			<div class="col-12 col-lg-12">
				<b-form-group class="mb-3" id="input-group-1" label-class="fw-bold" label="Name of Business/Church/Group *">
					<b-form-input v-model="form.businessName" type="text" placeholder="Name of Group" :disabled="submitted" :class="{ 'is-invalid': submitted && $v.form.businessName.$error }"></b-form-input>
					<div v-if="submitted && !$v.form.businessName.required" class="invalid-feedback">Field is required.</div>
				</b-form-group>
			</div>
			<!--/. col -->

			<!-- col -->
			<div class="col-12 col-lg-12">
				<div class="mb-3">
					<label class="fw-bold">How did you hear of MN Adult & Teen Challenge? *</label>
					<b-form-select class="form-select" v-model="form.howDidYouHear" :disabled="submitted" :options="howDidYouHearOptions" :class="{ 'is-invalid': submitted && $v.form.howDidYouHear.$error }">
						<template #first>
							<b-form-select-option :value="null" disabled>-- Select Options --</b-form-select-option>
						</template>
					</b-form-select>
					<div v-if="submitted && $v.form.howDidYouHear.$error" class="invalid-feedback">
						<span v-if="!$v.form.howDidYouHear.required">Field is required.</span>
					</div>
				</div>
			</div>
			<!--/. col -->

			<!-- col -->
			<div class="col-12 col-lg-12" v-if="form.howDidYouHear == 'Other'">
				<b-form-group class="mb-3" id="input-group-1" label-class="fw-bold" label="How did you hear of MN Adult & Teen Challenge? (Other) *">
					<b-form-input v-model="form.howDidYouHearOther" type="text" :disabled="submitted" placeholder="How did you hear of MN Adult & Teen Challenge? (Other)" :class="{ 'is-invalid': submitted && $v.form.howDidYouHearOther.$error }"></b-form-input>
					<div v-if="submitted && !$v.form.howDidYouHearOther.required" class="invalid-feedback">Field is required.</div>
				</b-form-group>
			</div>
			<!--/. col -->

			<!-- col -->
			<div class="col-12 col-lg-12">
				<b-form-group class="mb-3" id="input-group-1" label-class="fw-bold" label="Total Number of Volunteers *">
					<b-form-input v-model="form.numberOfVolunteers" type="number" :disabled="submitted" min="1" step="1" placeholder="Total Number of Volunteers" :class="{ 'is-invalid': submitted && $v.form.numberOfVolunteers.$error }"></b-form-input>
					<div v-if="submitted && !$v.form.numberOfVolunteers.required" class="invalid-feedback">Field is required.</div>
				</b-form-group>
			</div>
			<!--/. col -->

			<!-- col -->
			<div class="col-12 col-lg-12">
				<b-form-group class="mb-3" id="input-group-1" label-class="fw-bold" label="Type of Group *">
					<b-form-input v-model="form.groupType" type="text" :disabled="submitted" placeholder="Type of Group" :class="{ 'is-invalid': submitted && $v.form.groupType.$error }"></b-form-input>
					<div v-if="submitted && !$v.form.groupType.required" class="invalid-feedback">Field is required.</div>
				</b-form-group>
			</div>
			<!--/. col -->

			<!-- col -->
			<div class="col-12 col-lg-12">
				<label class="fw-bold">Group Leader *</label>
				<!-- row -->
				<div class="row">
					<!-- col -->
					<div class="col-12 col-lg-6">
						<b-form-group class="mb-3">
							<b-form-input v-model="form.groupLeader.firstName" type="text" :disabled="submitted" placeholder="First" :class="{ 'is-invalid': submitted && $v.form.groupLeader.firstName.$error }"></b-form-input>
							<div v-if="submitted && !$v.form.groupLeader.firstName.required" class="invalid-feedback">Field is required.</div>
						</b-form-group>
					</div>
					<!--/. col -->

					<!-- col -->
					<div class="col-12 col-lg-6">
						<b-form-group class="mb-3">
							<b-form-input v-model="form.groupLeader.lastName" type="text" :disabled="submitted" placeholder="Last" :class="{ 'is-invalid': submitted && $v.form.groupLeader.lastName.$error }"></b-form-input>
							<div v-if="submitted && !$v.form.groupLeader.lastName.required" class="invalid-feedback">Field is required.</div>
						</b-form-group>
					</div>
					<!--/. col -->
				</div>
				<!-- row -->
			</div>
			<!--/. col -->

			<!-- col -->
			<div class="col-12 col-lg-12">
				<b-form-group class="mb-3" id="input-group-1" label-class="fw-bold" label="Group Leader Title / Role *">
					<b-form-input v-model="form.groupLeader.title" type="text" :disabled="submitted" placeholder="Group Leader Title / Role" :class="{ 'is-invalid': submitted && $v.form.groupLeader.title.$error }"></b-form-input>
					<div v-if="submitted && !$v.form.groupLeader.title.required" class="invalid-feedback">Field is required.</div>
				</b-form-group>
			</div>
			<!--/. col -->

			<!-- col -->
			<div class="col-12 col-lg-6">
				<b-form-group class="mb-3" label-class="fw-bold" label="Phone (Cell) *">
					<b-form-input v-model="form.phone" type="number" :disabled="submitted" placeholder="" :class="{ 'is-invalid': submitted && $v.form.phone.$error }"></b-form-input>
					<div v-if="submitted && !$v.form.phone.required" class="invalid-feedback">Field is required.</div>
				</b-form-group>
			</div>
			<!--/. col -->

			<!-- col -->
			<div class="col-12 col-lg-6">
				<b-form-group class="mb-3" label-class="fw-bold" label="Email *">
					<b-form-input v-model="form.email" type="email" :disabled="submitted" placeholder="" :class="{ 'is-invalid': submitted && $v.form.email.$error }"></b-form-input>
					<div v-if="submitted && !$v.form.email.email" class="invalid-feedback">Email is in-valid.</div>
					<div v-if="submitted && !$v.form.email.required" class="invalid-feedback">Field is required.</div>
				</b-form-group>
			</div>
			<!--/. col -->

			<!-- col -->
			<div class="col-12 col-lg-12">
				<label class="fw-bold">Address of Business/Church/Group *</label>
				<!-- row -->
				<div class="row">
					<!-- col -->
					<div class="col-12 col-lg-6">
						<b-form-group class="mb-3">
							<b-form-input v-model="form.address.line1" type="text" :disabled="submitted" placeholder="Street Address" :class="{ 'is-invalid': submitted && $v.form.address.line1.$error }"></b-form-input>
							<div v-if="submitted && !$v.form.address.line1.required" class="invalid-feedback">Field is required.</div>
						</b-form-group>
					</div>
					<!--/. col -->

					<!-- col -->
					<div class="col-12 col-lg-6">
						<b-form-group class="mb-3">
							<b-form-input v-model="form.address.line2" type="text" :disabled="submitted" placeholder="Address Line 2"></b-form-input>
						</b-form-group>
					</div>
					<!--/. col -->

					<!-- col -->
					<div class="col-12 col-lg-6">
						<b-form-group class="mb-3">
							<b-form-input v-model="form.address.city" type="text" :disabled="submitted" placeholder="City" :class="{ 'is-invalid': submitted && $v.form.address.city.$error }"></b-form-input>
							<div v-if="submitted && !$v.form.address.city.required" class="invalid-feedback">Field is required.</div>
						</b-form-group>
					</div>
					<!--/. col -->

					<!-- col -->
					<div class="col-12 col-lg-6">
						<b-form-group class="mb-3">
							<b-form-input v-model="form.address.state" type="text" :disabled="submitted" placeholder="State" :class="{ 'is-invalid': submitted && $v.form.address.state.$error }"></b-form-input>
							<div v-if="submitted && !$v.form.address.state.required" class="invalid-feedback">Field is required.</div>
						</b-form-group>
					</div>
					<!--/. col -->

					<!-- col -->
					<div class="col-12 col-lg-12">
						<b-form-group class="mb-3">
							<b-form-input v-model="form.address.zipCode" type="text" :disabled="submitted" placeholder="ZIP Code" :class="{ 'is-invalid': submitted && $v.form.address.zipCode.$error }"></b-form-input>
							<div v-if="submitted && !$v.form.address.zipCode.required" class="invalid-feedback">Field is required.</div>
						</b-form-group>
					</div>
					<!--/. col -->
				</div>
				<!-- row -->
			</div>
			<!--/. col -->
		</div>
		<!--/.Row  -->

		<div class="d-flex justify-content-center mb-5">
			<b-button type="submit" variant="custom" :disabled="$v.form.$error || submitted">Submit</b-button>
		</div>
	</b-form>
</template>
